import React from 'react';

const styles = {
    container: {
        maxWidth: '800px',
        margin: '0 auto',
        padding: '40px 20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        color: '#333',
        lineHeight: '1.7',
    },
    header: {
        textAlign: 'center',
        marginBottom: '40px',
    },
    title: {
        fontSize: '2rem',
        fontWeight: '700',
        color: '#1a1a2e',
        marginBottom: '8px',
    },
    date: {
        color: '#666',
        fontSize: '0.9rem',
    },
    section: {
        marginBottom: '28px',
    },
    h2: {
        fontSize: '1.3rem',
        fontWeight: '600',
        color: '#1a1a2e',
        marginBottom: '12px',
        borderBottom: '2px solid #e8e8e8',
        paddingBottom: '6px',
    },
    p: {
        marginBottom: '12px',
        fontSize: '0.95rem',
    },
    ul: {
        paddingLeft: '24px',
        marginBottom: '12px',
    },
    li: {
        marginBottom: '6px',
        fontSize: '0.95rem',
    },
    backLink: {
        display: 'inline-block',
        marginBottom: '20px',
        color: '#6C63FF',
        textDecoration: 'none',
        fontWeight: '500',
    },
};

export default function TermsOfService() {
    return (
        <div style={styles.container}>
            <a href="/" style={styles.backLink}>← Back to OffTrigger</a>
            <div style={styles.header}>
                <h1 style={styles.title}>Terms of Service</h1>
                <p style={styles.date}>Last updated: February 15, 2026</p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>1. Acceptance of Terms</h2>
                <p style={styles.p}>
                    By accessing or using OffTrigger, you agree to be bound by these Terms of Service. If you do not agree, please do not use the service.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>2. Description of Service</h2>
                <p style={styles.p}>
                    OffTrigger is a lead management platform that helps real estate professionals capture, organize, and manage leads from multiple sources including email, Facebook Lead Ads, and other channels.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>3. User Accounts</h2>
                <ul style={styles.ul}>
                    <li style={styles.li}>You must provide accurate and complete registration information.</li>
                    <li style={styles.li}>You are responsible for maintaining the security of your account credentials.</li>
                    <li style={styles.li}>You must notify us immediately of any unauthorized account access.</li>
                    <li style={styles.li}>You must be at least 18 years old to use this service.</li>
                </ul>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>4. Acceptable Use</h2>
                <p style={styles.p}>You agree not to:</p>
                <ul style={styles.ul}>
                    <li style={styles.li}>Use the service for any illegal or unauthorized purpose.</li>
                    <li style={styles.li}>Violate any applicable laws or regulations, including data protection laws.</li>
                    <li style={styles.li}>Send spam or unsolicited communications through the platform.</li>
                    <li style={styles.li}>Attempt to gain unauthorized access to other users' data.</li>
                    <li style={styles.li}>Interfere with or disrupt the service or its infrastructure.</li>
                </ul>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>5. Third-Party Integrations</h2>
                <p style={styles.p}>
                    OffTrigger integrates with third-party services (Gmail, Facebook, Twilio). Your use of these integrations is subject to the respective third-party terms of service. We are not responsible for the availability or policies of third-party services.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>6. Data Ownership</h2>
                <p style={styles.p}>
                    You retain ownership of all lead data and content you create or import into OffTrigger. We do not claim ownership of your data. You grant us a limited license to process and store your data solely for the purpose of providing the service.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>7. Service Availability</h2>
                <p style={styles.p}>
                    We strive to maintain high availability but do not guarantee uninterrupted service. We may perform maintenance or updates that temporarily affect availability. We will make reasonable efforts to notify users of planned downtime.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>8. Limitation of Liability</h2>
                <p style={styles.p}>
                    OffTrigger is provided "as is" without warranties of any kind. We shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the service.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>9. Termination</h2>
                <p style={styles.p}>
                    We reserve the right to suspend or terminate your account for violation of these terms. You may terminate your account at any time by contacting us. Upon termination, your data will be deleted in accordance with our Privacy Policy.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>10. Contact Us</h2>
                <p style={styles.p}>
                    For questions about these Terms, contact us at: <strong>ashwinoffl.project@gmail.com</strong>
                </p>
            </div>
        </div>
    );
}
